import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8fd3defa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-container" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'

import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { ECHARTS_LINE_COLOR, getAssignLineOption, withLineSeriesStyle } from '@/utils/echarts-option/line'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import TimeRangeSelect from '@/views/dashboard/_components/time-range-select/time-range-select.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'

interface ChartData {
  times: string[]
  upload: number[]
  download: number[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'traffic-trend-chart',
  props: {
    data: { default: () => ({
    times: [],
    upload: [],
    download: []
  }) },
    timeRange: { default: TimeRange.DAYS_30 }
  },
  emits: ["update:timeRange"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
const props = __props

const emit = __emit

const timeRangeModel = computed({
  get: () => props.timeRange,
  set: (v) => emit('update:timeRange', v)
})

/** 系列配置 */
const SERIES_CONFIG = computed(() => [
  { field: 'upload', name: t('terminalTrafficStateList.uploadTraffic'), color: ECHARTS_LINE_COLOR.upload },
  { field: 'download', name: t('terminalTrafficStateList.downloadTraffic'), color: ECHARTS_LINE_COLOR.download },
])

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)

const chartData = computed(() => props.data)
const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

const chartOption = computed(() => {
  if (!chartData.value?.times?.length) {
    return { xAxis: { data: [] }, series: [] }
  }

  return {
    xAxis: {
      data: chartData.value.times,
    },
    legend: {
      width: chartInstance?.getWidth() ? chartInstance.getWidth() - 60 : 'auto',
    },
    series: SERIES_CONFIG.value.map(config => withLineSeriesStyle({
      name: config.name,
      data: chartData.value[config.field as keyof ChartData] as number[],
      smooth: true,
    }, config.color))
  }
})

function initChart () {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
  renderChart()
}

function renderChart () {
  if (!chartInstance) return
  const finalOption: any = getAssignLineOption(chartOption.value, { unit: 'GB' })
  chartInstance.setOption(finalOption)
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance && chartInstance.resize()
})

watch(() => chartData.value, () => {
  nextTick(() => {
    if (!chartData.value?.times?.length) {
      chartInstance?.clear()
      return
    }
    if (!chartInstance) {
      initChart()
    } else {
      renderChart()
    }
  })
}, { deep: true })

useEchartsThemeSync(renderChart)

onMounted(() => {
  nextTick(() => {
    if (chartData.value?.times?.length) {
      initChart()
    }
  })
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance && chartInstance.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: _ctx.$t('terminalTrafficStateList.trafficTrendTitle'),
    class: "traffic-trend-card-wrap"
  }, {
    headerRight: _withCtx(() => [
      _createVNode(TimeRangeSelect, {
        modelValue: timeRangeModel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRangeModel).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "chart-wrapper"
        }, null, 512)
      ], 512), [
        [_vShow, chartData.value?.times?.length]
      ]),
      _withDirectives(_createVNode(EmptyData, {
        height: "292px",
        "bg-color": "transparent"
      }, null, 512), [
        [_vShow, !chartData.value?.times?.length]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})